import type { ScheduleRunResult } from './scrapeSchedule';

export type CronTriggerResult = {
  ok: boolean;
  checked?: number;
  ran?: number;
  schedules?: Array<{
    id: string;
    name: string;
    result: ScheduleRunResult;
    next_run_at: string;
    incomplete?: boolean;
  }>;
  error?: string;
};

function siteRootPath(relativePath: string): string {
  const base = import.meta.env.BASE_URL || '/';
  const baseNorm = base === './' ? '/' : base;
  const prefix = baseNorm.endsWith('/') ? baseNorm.slice(0, -1) : baseNorm;
  const path = relativePath.startsWith('/') ? relativePath : `/${relativePath}`;
  return prefix ? `${prefix}${path}` : path;
}

function resolveTriggerUrl(): string {
  const fromEnv = (import.meta.env.VITE_SCRAPE_CRON_TRIGGER as string | undefined)?.trim();
  if (fromEnv) return fromEnv;

  if (typeof window !== 'undefined') {
    // /admin/... altında olsa bile PHP dosyası site kökündedir.
    return `${window.location.origin}${siteRootPath('scrape-cron-trigger.php')}`;
  }
  return siteRootPath('scrape-cron-trigger.php');
}

/** Admin panelden tek bir zamanlamayı anında çalıştırır (278 forum uzun sürebilir). */
export async function triggerScrapeCron(
  scheduleId: string,
  accessToken: string
): Promise<CronTriggerResult> {
  const url = resolveTriggerUrl();
  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Supabase-Authorization': `Bearer ${accessToken}`,
    },
    body: JSON.stringify({ schedule_id: scheduleId }),
  });

  let body: CronTriggerResult | null = null;
  try {
    body = (await res.json()) as CronTriggerResult;
  } catch {
    body = null;
  }

  if (!res.ok) {
    const msg =
      body?.error ??
      (res.status === 404
        ? 'scrape-cron-trigger.php bulunamadı. Site köküne yükleyin ve .htaccess güncel olsun.'
        : res.status === 503
          ? 'Cron yapılandırması eksik (service_role). CRON-KURULUM.md adım 2.'
          : `HTTP ${res.status}`);
    throw new Error(msg);
  }

  if (!body?.ok) {
    throw new Error(body?.error ?? 'Cron çalıştırılamadı');
  }

  return body;
}
